import { animated, useSpring } from '@react-spring/three';
import { OrbitControls } from '@react-three/drei';
import PropTypes from 'prop-types';

import CameraMap from './scene/CameraMap';
import LightsMap from './scene/LightsMap';
import World from './World';

function SceneMap({ themes, loading, finalProjectActions }) {
  const path = window.location.pathname;
  const { position } = useSpring({
    to: {
      position: path.includes('theme') ? [9, 0, -20] : [9, 10, -20],
    },
    from: { position: [20, 20, 20] },
    config: {
      mass: 3, tension: 100, friction: 34, precision: 0.02,
    },
  });
  return (
    <animated.group position={position}>
      <CameraMap />
      <LightsMap />
      {themes.length !== 0
        ? <World themes={themes} loading={loading} finalProjectActions={finalProjectActions} />
        : null}
      <OrbitControls
        maxAzimuthAngle={Math.PI}
        maxPolarAngle={Math.PI / 2}
        minAzimuthAngle={-Math.PI / 4}
        minPolarAngle={0}
      />
    </animated.group>
  );
}

export default SceneMap;

SceneMap.propTypes = {
  themes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
    PropTypes.array,
  ]))).isRequired,
  loading: PropTypes.func.isRequired,
  finalProjectActions: PropTypes.func.isRequired,
};
